import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useFormatter } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

const dataProviderName = 'calendars/carcalendarrecord';

const Detail = (params) => {
    const { t } = useTranslation();
    const { close: closeDrawer } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { formatDate, formatDateForInput } = useFormatter();

    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        const recordId = item?.data?.id ?? item?.data?._id ?? params?.id;
        const { carCalendar, employment, legalEntity, ...scalarFields } = data;
        const payload = {
            ...scalarFields,
            id: recordId,
            car_calendar_id: item?.data?.car_calendar_id ?? carCalendar?._id ?? carCalendar?.id,
            employment_id: item?.data?.employment_id ?? employment?._id ?? employment?.id,
            legal_entity_id: item?.data?.legal_entity_id ?? legalEntity?._id ?? legalEntity?.id,
            filters: params.filters,
        };
        save(payload).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState()
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    bookingStart_at: item?.data?.bookingStart_at,
                    bookingEnd_at: item?.data?.bookingEnd_at,
                    finalized_at: item?.data?.finalized_at,
                    notes: item?.data?.notes,
                    isApproved: item?.data?.isApproved,
                    carCalendar: item?.data?.carCalendar,
                    employment: item?.data?.employment,
                    legalEntity: item?.data?.legalEntity,
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.bookingStart_at ? t('Booking from {{start_at}} to {{end_at}} by {{firstname}} {{lastname}}', { start_at:formatDate(item?.data?.bookingStart_at), end_at:formatDate(item?.data?.bookingEnd_at), firstname:item?.data?.employment?.person?.firstname, lastname:item?.data?.employment?.person?.lastname }): t('New booking')}
                subtitle={item?.data?.scope && item?.data?.scope}
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            }
                        ]}
                    />
                ]}
                {...params}
            />

            {confirmDelete}
        </>
    )
}

export default Detail;



